import React from 'react';

const BluePromotionIcon = () => {

  return (

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0928 1.46875C14.2177 1.34385 14.4199 1.34395 14.5449 1.46875C14.6699 1.5937 14.6699 1.79592 14.5449 1.9209L13.2119 3.25391C13.2699 3.37955 13.3027 3.51947 13.3027 3.66699V7.81836C13.3018 8.07919 13.1981 8.32972 13.0137 8.51367L7.44336 14.083C7.05809 14.4677 6.43406 14.4679 6.04883 14.083L1.89551 9.93066C1.51081 9.54549 1.5117 8.92151 1.89648 8.53613L7.46875 2.96777C7.65376 2.78297 7.90466 2.67871 8.16602 2.67871L12.3164 2.68066C12.4798 2.68067 12.6339 2.72073 12.7695 2.79102L14.0928 1.46875ZM10.6797 4.03125C9.9627 4.03161 9.38122 4.6131 9.38086 5.33008C9.38104 6.04722 9.96259 6.62952 10.6797 6.62988C11.3971 6.62988 11.9793 6.04744 11.9795 5.33008C11.9794 5.08843 11.912 4.86275 11.7969 4.66895L11.3125 5.1543C11.3282 5.21067 11.3388 5.2697 11.3389 5.33105C11.3387 5.69495 11.0436 5.99023 10.6797 5.99023C10.316 5.98989 10.0207 5.69473 10.0205 5.33105C10.0207 4.96737 10.316 4.67222 10.6797 4.67188C10.7429 4.67188 10.8035 4.68357 10.8613 4.7002L11.3457 4.21582C11.1508 4.09917 10.9232 4.03125 10.6797 4.03125Z"
        fill="#08081B"
      />
      <mask
        id="mask0_1351_39729"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="14"
        height="14"
      >
        <path
          d="M14.0928 1.46875C14.2177 1.34385 14.4199 1.34395 14.5449 1.46875C14.6699 1.5937 14.6699 1.79592 14.5449 1.9209L13.2119 3.25391C13.2699 3.37955 13.3027 3.51947 13.3027 3.66699V7.81836C13.3018 8.07919 13.1981 8.32972 13.0137 8.51367L7.44336 14.083C7.05809 14.4677 6.43406 14.4679 6.04883 14.083L1.89551 9.93066C1.51081 9.54549 1.5117 8.92151 1.89648 8.53613L7.46875 2.96777C7.65376 2.78297 7.90466 2.67871 8.16602 2.67871L12.3164 2.68066C12.4798 2.68067 12.6339 2.72073 12.7695 2.79102L14.0928 1.46875ZM10.6797 4.03125C9.9627 4.03161 9.38122 4.6131 9.38086 5.33008C9.38104 6.04722 9.96259 6.62952 10.6797 6.62988C11.3971 6.62988 11.9793 6.04744 11.9795 5.33008C11.9794 5.08843 11.912 4.86275 11.7969 4.66895L11.3125 5.1543C11.3282 5.21067 11.3388 5.2697 11.3389 5.33105C11.3387 5.69495 11.0436 5.99023 10.6797 5.99023C10.316 5.98989 10.0207 5.69473 10.0205 5.33105C10.0207 4.96737 10.316 4.67222 10.6797 4.67188C10.7429 4.67188 10.8035 4.68357 10.8613 4.7002L11.3457 4.21582C11.1508 4.09917 10.9232 4.03125 10.6797 4.03125Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1351_39729)">
        <rect width="16" height="16" fill="url(#paint0_linear_1351_39729)" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1351_39729"
          x1="-1.9422"
          y1="18.2857"
          x2="17.7469"
          y2="15.6995"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0003" stopColor="#018299" />
          <stop offset="0.9999" stopColor="#006576" />
        </linearGradient>
      </defs>
    </svg>

  );
};

export default BluePromotionIcon;
